import React from 'react';
import { Outlet } from 'react-router-dom';

const UsersPage: React.FC = () => {
  return <Outlet />;
};

export default UsersPage;